// extracted by mini-css-extract-plugin
export var black = "_41-6";
export var brand = "_41-1";
export var ddefault = "_41-0";
export var error = "_41-3";
export var gray = "_41-2";
export var highContrast = "_41-8";
export var outline = "_41-7";
export var success = "_41-5";
export var warning = "_41-4";